module.exports = __webpack_public_path__ + "static/media/HE.ebed3403.svg";